export default "__VITE_ASSET__DE69kxpe__"